// components
import { Typography } from '@centria-ui-atoms/typography'
import { Skeleton } from '@centria-ui-atoms/skeleton'

// primeComponents
import { CascadeSelect as PrCascadeSelect } from 'primereact/cascadeselect'

// Styles
import classes from './styles.module.scss'

// Types
import type { CascadeSelectProps as PrCascadeSelectProps } from 'primereact/cascadeselect'
import type { InputsEnum, variantsEnum } from '@centria-ui/commons/enums'
import type { FC } from 'react'

export interface CascadeSelectProps extends PrCascadeSelectProps {
  label?: string
  inputVariant?: keyof typeof InputsEnum
  inputColor?: typeof variantsEnum.light | typeof variantsEnum.white
}

export const CascadeSelect: FC<CascadeSelectProps> = ({
  label,
  className = '',
  inputColor = 'light',
  inputVariant = 'block',
  ...props
}) => {
  return (
    <div>
      {label && (
        <Typography
          Tag='label'
          fontSize='small'
          className='mb-1'
          htmlFor={props.id}>
          {label}
        </Typography>
      )}
      {!props?.options ? (
        <div className='d-flex'>
          <Skeleton height='48px' width='100%' radius='lg' />
        </div>
      ) : (
        <div className={`${classes.cascadeWrapper} ${className} `}>
          <PrCascadeSelect
            className={`${classes.cascade} ${
              classes[`input_${inputVariant}`]
            } ${classes[`input_${inputColor}`]}`}
            pt={{
              wrapper: { className: classes.panelWrapper }
            }}
            {...props}
          />
        </div>
      )}
    </div>
  )
}
